module.exports = __webpack_public_path__ + "img/ring_r_c_1_0@2x.7133d6de.png";